import { render, staticRenderFns } from "./modal-score.vue?vue&type=template&id=ed65854e&"
import script from "./modal-score.vue?vue&type=script&lang=js&"
export * from "./modal-score.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports